import { Box, Card, Typography } from '@mui/material';
import usePatient from 'store/patient/usePatient';

const Precautions = () => {
  const { patientInfo } = usePatient();

  const toList = (v?: string | null) =>
    (v ?? '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

  const items = toList(patientInfo?.caution);

  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      overflow="auto"
      sx={{ border: '1px solid #cdcdcd', borderRadius: 1, mb: 1.5 }}
    >
      <Card
        component="section"
        sx={{ p: '12px 16px', height: '100%', overflow: 'auto' }}
      >
        <Typography sx={{ fontWeight: 800, mb: 1, fontSize: 15 }}>
          Анхааруулга
        </Typography>

        <Box component="ul" sx={{ pl: 4, m: 0 }}>
          {items.length ? (
            items.map((it, idx) => (
              <Typography
                component="li"
                key={`precaution-${idx}`}
                sx={{ fontSize: 14 }}
              >
                {it}
              </Typography>
            ))
          ) : (
            <Typography
              component="li"
              sx={{ color: 'text.disabled', fontSize: 14 }}
            >
              Хамааралгүй
            </Typography>
          )}
        </Box>
      </Card>
    </Box>
  );
};

export default Precautions;
